export default __webpack_public_path__ + "static/media/Wildstrider Armbands.3c88d0cd.jpg";